// src/components/LoadingSpinner.js
import React from 'react';
import '../styles/LoadingSpinner.css';

/**
 * FullScreenLoader - 全画面をカバーするローディングコンポーネント
 * ヘッダー・フッターも含めて完全に隠す
 */
const LoadingSpinner = ({ 
  text = "読み込み中...", 
  fullScreen = true
}) => {
  if (!fullScreen) {
    // インライン表示用（既存の動作を維持）
    return (
      <div className="loading-spinner-inline">
        <div className="loading-spinner-orb-inline">
          <div className="loading-spinner-ring-inline"></div>
        </div>
        <span className="loading-spinner-text-inline">{text}</span>
      </div>
    );
  }

  return (
    <div className="loading-overlay">
      {/* メインコンテンツ */}
      <div className="loading-content">
        {/* ロゴマーク風アニメーション */}
        <div className="loading-logo-container">
          <div className="loading-orb">
            <div className="loading-orb-ring loading-orb-ring-1"></div>
            <div className="loading-orb-ring loading-orb-ring-2"></div>
            <div className="loading-orb-ring loading-orb-ring-3"></div>
            <div className="loading-orb-core"></div>
          </div>
        </div>
        
        {/* テキスト */}
        <div className="loading-text-container">
          <span className="loading-text">{text}</span>
          <div className="loading-dots">
            <span className="loading-dot"></span>
            <span className="loading-dot"></span>
            <span className="loading-dot"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;